import React, {Component} from "react";
import PropTypes from "prop-types";
import HistoryItem from "./HistoryItem";
import {getHistories, subscribeHistories, unsubscribeHistory} from "../../services/HistoryServices";

class SearchHistories extends Component {
    state = {
        histories: getHistories()
    };

    componentDidMount() {
        subscribeHistories(this._handleChangeHistories);
    }

    componentWillUnmount() {
        unsubscribeHistory(this._handleChangeHistories);
    }

    _handleChangeHistories = () => {
        const histories = getHistories();

        this.setState({
            histories
        });
    };

    render() {
        const {histories} = this.state;

        return (
            <div className="SearchHistories col-md-3 col-sm-12">
                <h3 className="Title">History</h3>

                <div className="Histories">
                    {
                        histories.map(history => {
                            return (
                                <HistoryItem
                                    history={history}
                                    key={history.id}/>
                            );
                        })
                    }
                </div>
            </div>
        );
    }
}

SearchHistories.propTypes = {
    histories: PropTypes.array,
};

export default SearchHistories;


// WEBPACK FOOTER //
// ./src/app/home/SearchHistories.js